export enum OrderCostType {
  Purchase,
  Commission,
  Transit,
  Complaint,
  Repair,
  Administration,
  Other,
  Parking
}
